import Vue from 'vue';
import Router from 'vue-router';
import routes from './frontend';

Vue.use(Router);

const router =  new Router({
  //base: '/' + cmspath,
  base: '/',
  routes,
  mode: 'history',
  //linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    /*
    else {
      return { x: 0, y: 0 }
    }
    */
    /*
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
     */
  }
});

// router gards
/*
router.beforeEach((to, from, next) => {
  //NProgress.start();
  next(true);
});
*/

router.afterEach((to, from) => {
  // ...
  //NProgress.done();
  
  window.scrollTo(0, 0);
  
});


export default router;
